import React from 'react';
import PropTypes from 'prop-types';
import css from './Reason.css';
import Title from 'common/Title';
import LinkButton from "../../../SF/LinkButton";

export default class Reason extends React.Component {

  onClick(e) {
    if ( e ) e.preventDefault(); // Prevent errors on tests
    this.props.onChangeReasonClicked()
    return false;
  }

  get changeReasonLink() {
    return this.props.onChangeReasonClicked
      ? <LinkButton className={css['change-reason']}
                    onClick={this.onClick.bind(this)}
                    aria-label="Change reason">
        Change
      </LinkButton>
      : null;
  }

  render() {
    return (
      <div>
        <Title text="Reason for Visit" />
        <div className={css['text']}>
          <div>
            <span>{this.props.name}</span>
            {this.changeReasonLink}
          </div>
        </div>
      </div>
    );
  }
}

Reason.propTypes = {
  name: PropTypes.string.isRequired,
  onChangeReasonClicked: PropTypes.func
};
